/* eslint-disable @typescript-eslint/no-namespace */

export namespace PromiseUtils {
  export function delay(milliseconds: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds);
    });
  }
}
